export const state = {
  conseillers: null,
  advisor: null,
  clients: null,
}



// WEBPACK FOOTER //
// ./src/store/modules/Conseillers/state.js